/* eslint-disable camelcase */
import { privateFetcher } from 'services';
import { getIsDemoExperience } from 'services/globalConfig.services';

import APIError from 'exceptions/APIError';
import ENDPOINTS from 'constants/endpoints.constants';
import { ReturnTicketDTO } from 'services/returnTicket.service';

interface returnTicketPayload {
  shipment_pks?: any[];
  forward_shipment_pks?: any[];
  order_ids?: any[];
}

interface ReturnTicketResp {
  data: ReturnTicketDTO;
}

/**
 * All three maps must be present objects. The consumer in `shipment.services`
 * indexes straight into them, so a missing one throws a TypeError and the
 * shipment never renders — a blank page, not a blank section. snake_case,
 * because the response mapper is what reads it.
 *
 * Empty maps also keep the return button on the request path rather than
 * redirecting to an existing return.
 */
const DEMO_RETURN_TICKETS = {
  data: {
    shipment_pks: {},
    forward_shipment_pks: {},
    order_ids: {},
  },
} as unknown as ReturnTicketResp;

export const getReturnTicket = async (
  orgId: number,
  params: returnTicketPayload,
): Promise<ReturnTicketResp> => {
  if (getIsDemoExperience()) {
    return DEMO_RETURN_TICKETS;
  }

  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/return-tickets/${orgId}/`;
    const { data } = await privateFetcher.post(url, params);

    return data;
  } catch (error) {
    if (error.response) throw new APIError(error.response.data?.message, error);
    throw error;
  }
};
